import { ViewVehiclePanel } from "@/components/organisms";

export const ViewVehicle = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <ViewVehiclePanel />
    </div>
  );
};
